module.exports = new __parcel__URL__("righteousdefense.05fcfce7.png").toString();